import classNames from 'classnames';
import React from 'react';

import Text from '../text';

import {
  Progressbar as Props,
  variants,
  themes,
  labelAlignments,
  labelPositions,
} from './progress-bar.types';

const ProgressBar: React.FunctionComponent<Props> & {
  variants: typeof variants;
  themes: typeof themes;
  labelAlignments: typeof labelAlignments;
  labelPositions: typeof labelPositions;
} = ({
  value,
  max,
  label,
  labelAlignment = 'right',
  labelPosition,
  variant,
  theme,
}) => (
  <div
    className={classNames('progress-bar', {
      [`progress-bar--${labelPosition}`]: labelPosition,
    })}
  >
    <progress className="progress-bar__hidden" value={value} max={max} />
    <div
      className={classNames('progress-bar__progress', {
        [`progress-bar__progress--${theme}`]: theme,
      })}
    >
      <div
        className={classNames('progress-bar__bar', {
          [`progress-bar__bar--${variant}`]: variant,
          [`progress-bar__bar--${theme}`]: theme,
        })}
        style={{ width: `${Math.floor((value / max) * 100)}%` }}
      />
    </div>
    {label ? (
      <div
        className={classNames('progress-bar__text', {
          [`progress-bar__text--${theme}`]: theme,
        })}
      >
        {labelAlignment === 'left' ? (
          <Text elementName="span" size={Text.sizes.basic}>
            {label.text}
          </Text>
        ) : null}
        {label.boldText ? (
          <Text
            elementName="span"
            size={Text.sizes.basic}
            theme={Text.themes.emphasis}
          >
            {label.boldText}
          </Text>
        ) : undefined}
        {labelAlignment === 'right' ? (
          <Text elementName="span" size={Text.sizes.basic}>
            {label.text}
          </Text>
        ) : null}
      </div>
    ) : undefined}
  </div>
);

ProgressBar.variants = variants;
ProgressBar.themes = themes;
ProgressBar.labelAlignments = labelAlignments;
ProgressBar.labelPositions = labelPositions;
export default ProgressBar;
